import type { MetricName } from "schemas/generated/analyticsRead";

export const OVERVIEW_TABLE_METRICS: {
  key: MetricName;
  label: string;
  tooltip?: string;
}[] = [
  {
    key: "unique_sessions",
    label: "Sessions",
    tooltip:
      "Number of visits to your site. Visits starts when a user lands on a page and end when no events are sent for 30 minutes.",
  },
  {
    key: "conversions",
    label: "Conversions",
    tooltip:
      "The number of sessions where a purchase occurred after this page was the first one viewed.",
  },
  {
    key: "revenue",
    label: "Revenue",
    tooltip:
      "The total value of purchases that occurred after this page was the first one viewed.",
  },
  {
    key: "conversion_rates",
    label: "Conversion Rate",
    tooltip:
      "The percentage of sessions where this page was the first visited and led to a purchase.",
  },
  {
    key: "average_order_value",
    label: "AOV",
    tooltip:
      "The average order value from sessions where this page was the first one viewed.",
  },
  {
    key: "revenue_per_session",
    label: "Revenue per Session",
    tooltip:
      "The average revenue generated per session where this page was the first one viewed.",
  },
];

export const DETAILS_PAGE_CARD_METRICS: {
  label: string;
  key: MetricName;
}[] = [
  { label: "Conversion Rate", key: "conversion_rates" },
  { label: "Revenue/Session", key: "revenue_per_session" },
  { label: "Average Order Value", key: "average_order_value" },
  { label: "Total Sessions", key: "unique_sessions" },
  { label: "Total Conversions", key: "conversions" },
  { label: "Total Revenue", key: "revenue" },
];
